/* HERO VIDEO HARD CENTER FIX (desktop only) */
(function () {
  const mq = window.matchMedia("(min-width: 990px)");
  if (!mq.matches) return;

  // On ne dépend PLUS d'un ID fixe: on cible les sections HERO qui contiennent une video
  const CENTER_Y = "60%"; // si tu veux descendre un peu: "60%"

  function hardCenterVideo(video) {
    if (!video) return;

    // Force la video à se comporter comme un background cover centré
    video.style.setProperty("position", "absolute", "important");
    video.style.setProperty("top", CENTER_Y, "important");
    video.style.setProperty("left", "50%", "important");
    video.style.setProperty("transform", "translate(-50%, -50%)", "important");

    // Cover
    video.style.setProperty("width", "auto", "important");
    video.style.setProperty("height", "auto", "important");
    video.style.setProperty("min-width", "100%", "important");
    video.style.setProperty("min-height", "100%", "important");
    video.style.setProperty("object-fit", "cover", "important");
    video.style.setProperty("object-position", "50% 50%", "important");

    // Evite que des styles du thème déplacent encore le cadre
    video.style.setProperty("margin", "0", "important");
  }

  function ensureParentIsClipping(video) {
    const parent = video?.parentElement;
    if (!parent) return;

    // Le parent doit être le "cadre" (overflow hidden) sinon cover/translate ne sert à rien
    const cs = getComputedStyle(parent);
    if (cs.position === "static") parent.style.setProperty("position", "relative", "important");
    parent.style.setProperty("overflow", "hidden", "important");
  }

  function apply() {
    // Cible large: toute zone type "video background" + toute section qui contient une video
    const candidates = document.querySelectorAll(
      '.video-background, video-background-component, .video-placeholder-wrapper, deferred-media, section, .shopify-section'
    );

    candidates.forEach((root) => {
      // Ne traite que les blocs qui contiennent vraiment une video
      const videos = document.querySelectorAll(".hero__mobile-only video");
      if (!videos || videos.length === 0) return;

      videos.forEach((v) => {
        ensureParentIsClipping(v);
        hardCenterVideo(v);
      });
    });
  }

  function init() {
    apply();

    // Réapplique sur tous les événements vidéo (autoplay / play / lazyload)
    ["loadedmetadata", "canplay", "play", "playing"].forEach((evt) => {
      document.addEventListener(evt, apply, true);
    });

    // Réapplique si Shopify remplace la vidéo
    const mo = new MutationObserver(apply);
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Forçage agressif quelques secondes (scripts du thème qui passent après)
    let frames = 0;
    function tick() {
      apply();
      frames += 1;
      if (frames < 180) requestAnimationFrame(tick); // ~3s à 60fps
    }
    requestAnimationFrame(tick);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();